<template>
	<div>
		<v-app-bar flat color="#f5f9ff" style="z-index: 1;" v-if="$vuetify.breakpoint.mdAndUp">
			<v-container>
				<v-row justify="space-between">
					<v-img src="/logo-wide.png" contain max-height="40" max-width="200" />
					<v-row align="center" dense>
						<v-btn text color="primary" large>دسته‌بندی‌ها</v-btn>
						<v-btn text color="primary" large @click="goToShop()">فروشگاه</v-btn>
						<v-btn text color="primary" large>راهنما و پشتیبانی</v-btn>
					</v-row>
					<v-spacer />
					<v-btn @click="goToLogin" outlined class="rounded-xl" color="primary">ورود به پنل کاربری</v-btn>
					<v-btn @click="toggleEditMode" v-if="isAdmin" outlined class="rounded-xl mr-1" color="red">{{ editMode ? 'خروج از ویرایش' : 'حالت ویرایش' }}</v-btn>
				</v-row>
			</v-container>
		</v-app-bar>
		<v-app-bar flat color="#f5f9ff" style="z-index: 1;border-bottom: 1px solid #ddd;" v-if="$vuetify.breakpoint.smAndDown">
			<v-container>
				<v-row justify="space-between">
					<v-img src="/logo-wide.png" contain max-height="40" max-width="100" />
					<v-spacer />
					<v-btn @click="goToLogin" outlined class="rounded-xl" color="primary">ورود به پنل کاربری</v-btn>
				</v-row>
			</v-container>
		</v-app-bar>
		<v-bottom-navigation elevation="0" v-model="nav" active fixed color="primary" v-if="$vuetify.breakpoint.smAndDown" style="background-color: #f5f9ff;border-top: 1px solid #ddd;box-shadow: none;">
			<v-btn>
				دسته‌بندی‌ها
				<v-icon>mdi-history</v-icon>
			</v-btn>
			<v-btn @click="goToShop()">
				فروشگاه
				<v-icon>mdi-cart-outline</v-icon>
			</v-btn>
			<v-btn>
				راهنما و پشتیبانی
				<v-icon>mdi-comment-question-outline</v-icon>
			</v-btn>
			<v-btn @click="goToLogin">
				ورود به پنل
				<v-icon>mdi-account-outline</v-icon>
			</v-btn>
		</v-bottom-navigation>
	</div>
</template>

<script>
	import { get, call } from 'vuex-pathify'
	import router from '@/router'
	// Utilities

	export default {
		name: 'LandingAppBar',

		components: {

		},
		data() {
			return {
				nav: ''
			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle', 'isCloud'
			]),
			...get('appSettings', [
				'landingSettings'
			]),
			...get('auth', [
				'isAdmin', 'getCurrentUser'
			]),
			...get('app', [
				'editMode'
			]),
			showRegisterBtn() {
				return (!this.isCloud || (this.isCloud && this.$route.params.customerCode)) && !this.getCurrentUser
			},
			businessTitle() {
				return this.landingSettings?.businessTitle || this.longTitle
			},
			shopLink() {
				return this.landingSettings?.shopLink
			},
			shopTitle() {
				return this.landingSettings?.shopTitle || 'وب سایت فروشگاه'
			}
		},
		methods: {
			toggleEditMode: call('app/toggleEditMode'),
			goToLogin() {
				router.push({ name: 'Login' }).catch(() => { })
			},
			routeToPlans() {
				// this.$route.params
				this.$router.replace('/cl/plans/' + (this.$route.params.customerCode ? this.$route.params.customerCode : '')).catch(() => { })
			},
			goToRegister() {
				router.push({ name: 'Register', params: { customerCode: this.$route.params.customerCode || 0 } }).catch(() => { })
			},
			goToShop() {
				window.open(this.shopLink, '_blank').focus()
			}
		},
	}
</script>

<style lang="sass">
</style>
